import { Toaster } from "react-hot-toast";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import "./ResponseMessage.scss";

const MOBILE_BOTTOM_OFFSET = 80;
const DESKTOP_BOTTOM_OFFSET = 48;

const ResponseMessage = () => {
  const isMobile = useDeviceType() === deviceTypeEnum.PHONE;

  return (
    <Toaster
      position="bottom-center"
      reverseOrder={true}
      containerStyle={{
        left: 8,
        right: 8,
        bottom: isMobile ? MOBILE_BOTTOM_OFFSET : DESKTOP_BOTTOM_OFFSET
      }}
      toastOptions={{
        className: "toastItem",
      }}
    />
  );
};

export default ResponseMessage;
